export const ACESSO_PAINEL_ADMINISTRATIVO = 'ACESSO_PAINEL_ADMINISTRATIVO';
